module.exports = new __parcel__URL__("Sales Portal.753ff2da.svg").toString();